var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74374 11.9288C7.08542 12.2914 7.08542 12.8794 6.74374 13.242C6.40194 13.6046 5.84802 13.6046 5.50622 13.242L0.256263 7.67051C-0.0854211 7.3079 -0.0854211 6.71993 0.256263 6.35733L5.50622 0.785872C5.84802 0.423264 6.40194 0.423264 6.74374 0.785872C7.08542 1.14848 7.08542 1.73644 6.74374 2.09905L3.06766 6.00024H16.2308C18.026 6.00024 19.7478 6.79046 21.0173 8.19691C22.2868 9.60347 23 11.5111 23 13.5003C23 15.4893 22.2868 17.397 21.0173 18.8036C19.7478 20.21 18.026 21.0002 16.2308 21.0002H6.92299C6.45574 21.0002 6.0769 20.5805 6.0769 20.0627C6.0769 19.545 6.45574 19.1253 6.92299 19.1253H16.2308C17.5773 19.1253 18.8685 18.5326 19.8206 17.4777C20.7728 16.4229 21.3077 14.9921 21.3077 13.5003C21.3077 12.0085 20.7728 10.5777 19.8206 9.52281C18.8685 8.46789 17.5773 7.87523 16.2308 7.87523H2.92409L6.74374 11.9288Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.327975f911d667180c80b289f37bbf61.svg";
export { ForwardRef as ReactComponent };